import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { contentMaskHideAction } from 'components/header/content-mask/actions';
import { getCustomerSelector } from 'common/selectors';
import { useTranslation } from 'react-i18next';

export const Logo = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const customer = useSelector(getCustomerSelector);

  const hideMenu = () => dispatch(contentMaskHideAction());

  return (
    <div className="ct-logo">
      {customer && customer.homepageUrl ? (
        <a
          href={customer.homepageUrl}
          aria-label={customer.homepageUrlText}
          className="ct-logo__link"
          target="_self"
          rel="noopener noreferrer"
        >
          <div className="ct-logo__image" />
        </a>
      ) : (
        <Link aria-label={t('go_to_homepage')} className="ct-logo__link" to="/" onClick={hideMenu}>
          <div className="ct-logo__image" />
        </Link>
      )}
    </div>
  );
};
